import Vue from 'vue'
import VueRouter from 'vue-router'
import route from '@/routerList'
import generateRouter from '@hnkj/vax_tool/router'
Vue.use(VueRouter)
const routes = generateRouter(route)
const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes
})
router.beforeEach((from, to, next) => {
  const peach = Vue.prototype.$peach
  peach.logPage()
  next()
})
export default router
